module.exports = __webpack_public_path__ + "static/media/Kathleen Rakestraw Headshot.b225922a.jpg";